// How to use
// put GLOBAL_ROUTEDEFS to your layout.module.ts file
//  
// @NgModule({
//     imports: GLOBAL_ROUTEDEFS,
//     exports: [RouterModule]
// })

import { Routes, RouterModule } from '@angular/router';

import { CHILDROUTES as UrlRewriterCHILDROUTES } from "UrlRewriter/assembly";
import { MENUS as UrlRewriterMENUS } from "UrlRewriter/assembly";
import { CHILDROUTES as DataImporterCHILDROUTES } from "DataImporter/assembly";
import { MENUS as DataImporterMENUS } from "DataImporter/assembly";
import { CHILDROUTES as AdminPermissionCHILDROUTES } from "AdminPermission/assembly";
import { MENUS as AdminPermissionMENUS } from "AdminPermission/assembly";
import { CHILDROUTES as SEOCHILDROUTES } from "SEO/assembly";
import { MENUS as SEOMENUS } from "SEO/assembly";
import { CHILDROUTES as AdminSalesCHILDROUTES } from "AdminSales/assembly";
import { MENUS as AdminSalesMENUS } from "AdminSales/assembly";
import { CHILDROUTES as CMSCHILDROUTES } from "CMS/assembly";
import { MENUS as CMSMENUS } from "CMS/assembly";
import { ROOTROUTES as AdminROOTROUTES } from "Admin/assembly";
import { CHILDROUTES as AdminCHILDROUTES } from "Admin/assembly";
import { MENUS as AdminMENUS } from "Admin/assembly";

export { AppModule } from 'Admin/app.module';

const NOTFOUNDROUTES: Routes = [
{ path: 'not-found', loadChildren: 'Admin/not-found/not-found.module#NotFoundModule' },
{ path: '**', redirectTo: 'not-found' }
];

export const ROOTROUTES_DEFINES = [ RouterModule.forRoot(AdminROOTROUTES),RouterModule.forRoot(NOTFOUNDROUTES) ];

export const CHILDROUTES_DEFINES = [ RouterModule.forChild(UrlRewriterCHILDROUTES),RouterModule.forChild(DataImporterCHILDROUTES),RouterModule.forChild(AdminPermissionCHILDROUTES),RouterModule.forChild(SEOCHILDROUTES),RouterModule.forChild(AdminSalesCHILDROUTES),RouterModule.forChild(CMSCHILDROUTES),RouterModule.forChild(AdminCHILDROUTES) ];

export const MENUS_DEFINES = [ UrlRewriterMENUS,DataImporterMENUS,AdminPermissionMENUS,SEOMENUS,AdminSalesMENUS,CMSMENUS,AdminMENUS ];